<template>
  <div class="container" style="z-index: 0; position: relative">
    <div style="height:32px;width:100%;" />
    <Layout class="layout" :style="{ height:fullHeight+'px'}">
      <Sider
        ref="side"
        class="side-bar"
        style="min-width: 272px; max-width: 272px"
        :style="{
          width: '272px',
          height: '100%',
          background: '#fff',
          overflow: 'auto',
        }"
        :collapsed-width="78"
      >
        <Menu
          style="height: 100%"
          :active-name="activeName"
          :open-names="openNames"
          theme="light"
          width="auto"
          @on-select="onSelect"
        >
          <div class="user-icon">
            <div class="user-img">
              <img :src="levelAvatar">
            </div>
            <p class="user-name">{{ userInfo.nickname }}</p>
            <img :src="levelPic">
          </div>
          <Submenu name="0">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_info.png">
              </div>
              <span>会员资料</span>
            </template>
            <MenuItem name="myInfo">会员信息</MenuItem>
            <MenuItem name="changePwd">修改密码</MenuItem>
            <MenuItem name="logout">账号注销</MenuItem>
            <MenuItem name="invoice">发票抬头管理</MenuItem>
            <MenuItem v-if="userInfo.agentId && userInfo.checkStatus === 1" name="enterpriseAuthorization">企业授权认证</MenuItem>
          </Submenu>
          <Submenu name="1">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_address.png">
              </div>
              <span>收货地址</span>
            </template>
            <MenuItem name="myAddress">我的收货地址</MenuItem>
            <MenuItem name="addAddress">添加收货地址</MenuItem>
          </Submenu>
          <!-- <Submenu name="2">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_order.png">
              </div>
              <span>购物订单</span>
            </template>
            <MenuItem name="myOrder">我的订单</MenuItem>
          </Submenu> -->
          <MenuItem name="myOrder">
            <div class="item-icon">
              <img src="../assets/imgs/personal/my_order.png">
            </div>
            <span>购物订单</span>
          </MenuItem>
          <!-- <Submenu name="3">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_cart.png">
              </div>
              <span>购物车</span>
            </template>
            <MenuItem name="myShoppingCart">我的购物车</MenuItem>
          </Submenu> -->
          <MenuItem name="myShoppingCart">
            <div class="item-icon">
              <img src="../assets/imgs/personal/my_cart.png">
            </div>
            <span>购物车</span>
          </MenuItem>
          <Submenu v-show="giftFlag" name="4">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_card.png" style="width: 11px">
              </div>
              <span>提货券</span>
            </template>
            <MenuItem name="myGiftCard">我的提货券</MenuItem>
          </Submenu>
          <!-- <Submenu name="5">
            <template slot="title">
              <div class="item-icon">
                <img src="../assets/imgs/personal/my_coupon.png" style="width: 11px">
              </div>
              <span>优惠券</span>
            </template>
            <MenuItem name="myCoupon">我的优惠券</MenuItem>
          </Submenu> -->
          <MenuItem name="myCoupon">
            <div class="item-icon">
              <img src="../assets/imgs/personal/my_coupon.png" style="width: 11px">
            </div>
            <span>优惠券</span>
          </MenuItem>
          <MenuItem v-show="false" name="myCollect">
            <div class="item-icon">
              <img src="../assets/imgs/personal/my_collect.png">
            </div>
            <span>我的收藏</span>
          </MenuItem>
          <MenuItem name="myLEDConfig">
            <div class="item-icon">
              <i class="el-icon-s-tools" />
            </div>
            <span>屏管家历史配置</span>
          </MenuItem>
        </Menu>
      </Sider>
      <Layout class="layout">
        <Header :style="{ background: '#fff' }">
          <h2>{{ activeTitle }}</h2>
        </Header>
        <Content class="content">
          <transition mode="out-in">
            <router-view />
          </transition>
        </Content>
      </Layout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { memberInfo } from '@/api/member.js'
import { homeGiftCardOpen } from '@/api/gift.js'
const default_avatar = require('@/assets/imgs/personal/default_avatar.png')
const default_copper = require('@/assets/imgs/personal/default_copper.png')
const default_silver = require('@/assets/imgs/personal/default_silver.png')
const default_gold = require('@/assets/imgs/personal/default_gold.png')

const tag_10 = require('@/assets/imgs/personal/tag-10.svg')
const tag_1 = require('@/assets/imgs/personal/tag-1.svg')
const tag_11 = require('@/assets/imgs/personal/tag-11.svg')
const tag_2_4 = require('@/assets/imgs/personal/tag-2-4.svg')
const tag_2_5 = require('@/assets/imgs/personal/tag-2-5.svg')
const tag_2_6 = require('@/assets/imgs/personal/tag-2-6.svg')
const tag_2_7 = require('@/assets/imgs/personal/tag-2-7.svg')
const tag_3_8 = require('@/assets/imgs/personal/tag-3-8.svg')
const tag_3_9 = require('@/assets/imgs/personal/tag-3-9.svg')

export default {
  name: 'Home',
  data() {
    return {
      activeTitle: '会员信息',
      bar: {
        myAddress: '我的收货地址',
        addAddress: '添加收货地址',
        myOrder: '我的订单',
        myShoppingCart: '我的购物车',
        myInfo: '会员信息',
        changePwd: '修改密码',
        logout: '账号注销',
        myCollect: '我的收藏',
        invoice: '发票抬头管理',
        myGiftCard: '我的提货券',
        myCoupon: '我的优惠券',
        evaluate: '评价',
        myLEDConfig: '屏管家历史配置'
      },
      levelPic: '',
      levelAvatar: '',
      fullHeight: document.documentElement.clientHeight - 50,
      memberAvatar: [
        default_avatar, // 普通会员/内部员工 10/11
        default_copper, // 企业员工 1
        default_silver, // 代理商 2
        default_gold // 分销商 3
      ],
      firstLevelIcon: {
        tag_1, // 企业用户
        tag_10, // 普通用户
        tag_11 // 内部员工
      },
      secondLevelIcon: {
        tag_2_4,
        tag_2_5,
        tag_2_6,
        tag_2_7,
        tag_3_8,
        tag_3_9
      },
      giftFlag: false,
      activeName: 'MyInfo',
      openNames: ['0'],
      menus: [
        ['myInfo', 'changePwd', 'invoice'],
        ['myAddress', 'addAddress'],
        ['myOrder'],
        ['myShoppingCart'],
        ['myGiftCard'],
        ['myCoupon'],
        ['evaluate']
      ],
      requestId: '',
      timer: null
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  watch: {
    $route: {
      handler(val, old) {
        this.setTitle()
        if (val.name === 'homeIndex') {
          this.openNames = ['0']
          this.activeName = 'myInfo'
        } else {
          const index = this.menus.findIndex(item => item.includes(val.name))
          this.openNames = [index + '']
          this.activeName = val.name
        }
      },
      deep: true,
      immediate: true
    },
    userInfo: {
      handler: function(newV, oldV) {
        this.showLevel()
      },
      deep: true
    }
  },
  created() {
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  mounted() {
    this.setTitle()
    this.getInfo()
    // this.getHomeGiftCardOpen()
  },
  methods: {
    ...mapActions(['setUserInfo']),
    handleResize() {
      this.fullWidth = document.documentElement.clientWidth
      this.fullHeight = document.documentElement.clientHeight - 50
    },
    setTitle() {
      const arr = this.$route.path.split('/')
      if (arr.length === 3) {
        // 直接跳转了子路由
        const name = arr[2]
        this.activeTitle = this.bar[name]
      } else if (arr.length === 2) {
        // 此时为/home
        this.activeTitle = '会员信息'
      }
    },
    onSelect(name) {
      clearInterval(this.timer)
      this.activeTitle = this.bar[name]
      this.$router.push(`/home/${name}`)
    },
    showLevel() {
      // 企业类用户包括 1企业用户 2代理商 3分销商 4代理商-银牌增值 5代理商-经销商 6代理商-金牌增值 7代理商-行业方案 8分销商-银牌分销 9分销商-钻石分销
      // agentId存在表示企业类用户 checkStatus为1表示审核成功 审核成功的企业类用户
      if (this.userInfo.agentId && this.userInfo.checkStatus === 1) {
        // 兼容历史数据-不存在memberLevelId默认为企业用户
        if (!this.userInfo.memberLevelId) {
          this.levelAvatar = this.memberAvatar[1]
          this.levelPic = this.firstLevelIcon.tag_1
        } else {
          // avatar取一级LevelId的
          this.levelAvatar = this.memberAvatar[this.userInfo.memberLevelId]
          // 表示取二级SecondLevelId的
          if (this.userInfo.memberSecondLevelId) {
            this.levelPic = this.secondLevelIcon[`tag_${this.userInfo.memberLevelId}_${this.userInfo.memberSecondLevelId}`]
          } else {
            // 不存在二级Id，则取一级的
            this.levelPic = this.firstLevelIcon[`tag_${this.userInfo.memberLevelId}`]
          }
        }
      } else {
        // 非企业类用户包括 10普通会员 11内部员工
        // avatar取普通用户的
        this.levelAvatar = this.memberAvatar[0]
        this.levelPic = this.firstLevelIcon[`tag_${this.userInfo.memberLevelId}`]
      }
    },
    getInfo() {
      memberInfo().then((response) => {
        this.setUserInfo(response.data)
        this.showLevel()
      })
    },
    // 隐藏提货券
    getHomeGiftCardOpen() {
      homeGiftCardOpen().then(res => {
        this.giftFlag = res.data
      })
    }
  }
}
</script>

<style scoped>
.side-bar a {
  color: #232323;
}
.side-bar::-webkit-scrollbar {
  display: none;
}
.side-bar {
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.user-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
}
.user-icon span {
  font-size: 96px;
}
.user-img {
  margin-top: 40px;
  width: 120px;
  height: 120px;
  border-radius: 60px;
}
.user-img img {
  width: 100%;
}
.user-name {
  margin-top: 16px;
  color: #3d3d3d;
  font-size: 18px;
}
.item-icon {
  width: 12px;
  height: 12px;
  float: left;
  margin-right: 14px;
}
.content {
  margin: 15px;
  background-color: #fff;
  padding: 15px;
  overflow: auto;
}
.layout-footer-center {
  padding: 0px 15px;
  padding-bottom: 15px;
  text-align: center;
}
</style>
